import { DatePipe } from '@angular/common'
import { assertNever, quillHTMLToText } from 'src/app/helpers/helpers'
import { BaseTableData } from 'src/app/helpers/table-column-types'
import { TableColumn, TemplateTypes } from "src/app/helpers/table.data"
import { labelHexColorsToNames } from 'src/app/services/ui.service'
import { taskStatusNames } from 'globals/store/tasks.data'
import { flatten, justTimeToHHMM } from 'globals/helpers/helpers'


export const exportNestedTable = (columns: TableColumn[], items: BaseTableData[], datePipe: DatePipe): string[][] => {
  const columnNames = flatten(columns.map(c => !c.extraColumnData ? [c.exportColumnName || c.title] : [c.exportColumnName || c.title, ...c.extraColumnData.map(n => n.columnName)])).map(quillHTMLToText)
  
  const rows = items.map(row => flatten(columns.map((col) => {
    switch (col.templateId) {
      case 'tableImage': {
        const c: TemplateTypes['tableImage'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [c.fullUrl || c.url || ""]
      }
      case 'tableTextLights': {
        const c: TemplateTypes['tableTextLights'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        // console.log("tableTextLightsCell", c)
        if (c.url) return [c.url];
        return [c.greyText ? c.greyText : c.lights.map(l => l.text).join("")] // commas are added in the reselectors
      }
      case 'tableUpdatedText': {
        const c: TemplateTypes['tableUpdatedText'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [`${datePipe.transform(c.lastUpdated, 'h:mmaaaaa\'m\', d MMM yyyy')} by ${c.updater}`]
      }
      case 'tableLightsMap': {
        console.log("NO IMPLEMENTATION FOR TABLE LIGHTS MAP (SHOULD ONLY BE FOR NESTED TABLES)")
        return [""]
      }
      case 'tableDate': {
        const c: TemplateTypes['tableDate'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })

        if (!c) return [""]
        const dateOrDayString = (c.day ? c.day : datePipe.transform(c.date, 'd MMMM y')) || '';
        if (!c.extraDateData) {
          return [`${c.HHMMText || ''}${dateOrDayString}`]
        } else {
          return [`${c.HHMMText || ''}${dateOrDayString}`, ...c.extraDateData, dateOrDayString]
        }
      }
      case 'tableText': {
        const c: TemplateTypes['tableText'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [c.text || ""]
      }
      case 'tableLabels': {
        const c: TemplateTypes['tableLabels'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [c.map(l => l.label || `(${labelHexColorsToNames[l.color]})`).join(", ")]
      }
      case 'tableUser': {
        const c: TemplateTypes['tableUser'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [...(col.extraColumnData || []).map(c => ""), ""]
        const data = [c.name || ""]
        if (!col.extraColumnData) return data
        col.extraColumnData.forEach(ECD => {
          switch (ECD.id) {
            case "photo":
              data.push(c.fullPhotoUrl || c.photoUrl || "")
            break;
          }
        })
        return data
      }
      case 'tableEntity': {
        const c: TemplateTypes['tableEntity'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [`${c.entity?.name || ""}`]
      }
      case 'tableAccount': {
        const c: TemplateTypes['tableAccount'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [`${c.name}`]
      }
      case 'tableWorker': {
        const c: TemplateTypes['tableWorker'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [`${c.firstName || ""}${c.firstName && c.lastName ? " " : ""}${c.lastName}`]
      }
      case 'tableEmail': {
        const c: TemplateTypes['tableEmail'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [c.text || ""]
      }
      case 'tableLink': {
        const c: TemplateTypes['tableLink'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [c.url || ""]
      }
      case 'tableSocial': {
        const c: TemplateTypes['tableSocial'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [c.map(s => `${s.type}:${s.url}`).join(", ")]
      }
      case 'boldText': {
        const c: TemplateTypes['boldText'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [c.text || ""]
      }
      case 'tableHHMM': {
        const c: TemplateTypes['tableHHMM'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [justTimeToHHMM(c.time)]
      }
      case 'iconText': {
        const c: TemplateTypes['iconText'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [c.text || ""]
      }
      case 'tableCheck': {
        const c: TemplateTypes['tableCheck'] = row[col.id]
        if (!c) return [""]
        return [c.on ? "y" : ""]
      }
      case 'tableFlag': {
        const c: TemplateTypes['tableFlag'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [c.flagged ? "y" : ""]
      }
      case 'tableComments': {
        const c: TemplateTypes['tableComments'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [`${c.comments || ""}`]
      }
      case 'tableFiles': {
        const c: TemplateTypes['tableFiles'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [`${c.files || ""}`]
      }
      case 'tableStars': {
        const c: TemplateTypes['tableStars'] = row[col.id]
        // if (!c) console.log({ row, colId: col.id })
        if (!c) return [""]
        return [`${c.stars || ""}`]
      }
      case 'taskStatus': {
        const c: TemplateTypes['taskStatus'] = row[col.id]
        if (!c?.task?.status) return [""]
        return [ taskStatusNames[c.task.status] ]
      }

      default: 
        return assertNever(col.templateId) // ensures that all keys are used.  Remove / comment out one of the cases above to see it working in action.
    }
  }), false).map(quillHTMLToText))
  window['rows'] = rows
  const table2DArray = [columnNames, ...rows]
  console.log({ table2DArray })
  return table2DArray
}